export enum EnforcementMode {
	OFF = "off",
	SOFT = "soft",
	HARD = "hard",
}

export interface PlatformVersionConfig {
	minimum_supported_version: string;
	enforcement_mode: EnforcementMode;
}

export interface AppVersionConfig {
	ios: PlatformVersionConfig;
	android: PlatformVersionConfig;
}

/**
 * Compare two version strings (e.g., "1.0.27" vs "1.25").
 * Splits on ".", compares each part numerically, pads missing parts with 0.
 * Returns -1 if a < b, 0 if equal, 1 if a > b.
 */
export function compareSemver(a: string, b: string): -1 | 0 | 1 {
	const partsA = a.split(".").map(Number);
	const partsB = b.split(".").map(Number);
	const maxLen = Math.max(partsA.length, partsB.length);

	for (let i = 0; i < maxLen; i++) {
		const numA = partsA[i] ?? 0;
		const numB = partsB[i] ?? 0;
		if (numA < numB) return -1;
		if (numA > numB) return 1;
	}
	return 0;
}

/**
 * Fetch version enforcement config from the backend.
 * Uses raw fetch (not axios) because this runs before auth is established.
 * Returns null on any error (fail open).
 */
export async function fetchAppVersionConfig(baseURL: string): Promise<AppVersionConfig | null> {
	try {
		const response = await fetch(`${baseURL}/app-version/check`, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});
		if (!response.ok) return null;
		return await response.json();
	} catch {
		return null;
	}
}
